module.exports = __webpack_public_path__ + "img/sce_p1_img_12.c624ae54.png";